module.exports = __webpack_public_path__ + "static/netlify-03-c4ec3692d1bbd0bf064f0ab49f8c43b8.png";